import {
  EmulatedUseQueryResult,
  GenericReportResponse,
} from 'components/ChatBV/types';

import { SEARCH_TYPES } from '../constants';

export const formatText = (text: string) => {
  let processedText = text;

  if (text) {
    // Only try to parse as JSON if it looks like a JSON string
    if (text.startsWith('"') && text.endsWith('"')) {
      try {
        processedText = JSON.parse(text);
      } catch (_error) {
        // If JSON parsing fails, use the original text
        processedText = text;
      }
    }

    // Only handle escaped characters if they actually exist in the text
    const textToProcess = processedText?.toString() || '';
    if (
      textToProcess.includes('\\n') ||
      textToProcess.includes('\\"') ||
      textToProcess.includes('\\t') ||
      textToProcess.includes('\\r') ||
      (textToProcess.startsWith('"') && textToProcess.endsWith('"'))
    ) {
      const unescapedText = textToProcess
        .replace(/\\n/g, '\n')
        .replace(/\\"/g, '"')
        .replace(/\\t/g, '\t')
        .replace(/\\r/g, '\r')
        .replace(/^"|"$/g, ''); // Remove quotes from start and end

      processedText = unescapedText;
    }
  }

  return processedText;
};

export const copyProcessedText = async (content: string): Promise<boolean> => {
  try {
    const processedText = formatText(content);

    // Here we use regular expressions to remove the bold tags from the text, since the bold tags are not supported by the clipboard
    const cleanText = processedText.replace(/\*\*([^*]+)\*\*/g, '$1');

    await navigator.clipboard.writeText(cleanText);
    return true;
  } catch (_err) {
    return false;
  }
};

export const getEmulatedUseQueryResult = (
  reportData: GenericReportResponse,
  isSuccess: boolean,
  isLoading: boolean,
  isError: boolean
): EmulatedUseQueryResult => {
  return {
    data: reportData,
    isSuccess,
    isLoading,
    isError,
  };
};

export const getTrailingSpaceForType = (
  type: string,
  triggeredBySuggestion: boolean
) => {
  if (type === SEARCH_TYPES.PROPERTY) {
    if (triggeredBySuggestion) {
      return '  ';
    }
    return ' ';
  } // 2 spaces

  if (
    type === SEARCH_TYPES.PERSON ||
    type === SEARCH_TYPES.PHONE ||
    type === SEARCH_TYPES.EMAIL ||
    type === SEARCH_TYPES.VEHICLE
  )
    return ' ';
  return '';
};
